module.exports = __webpack_public_path__ + "img/Icon_Report_4.78c0af3f.png";